module.exports = __webpack_public_path__ + "static/media/10_of_diamonds.1c4f8001.png";